<template lang="pug">
#approve-member
  .page-controls
    spinner(v-if="settings.loading")
    b-notification(v-else-if="error" type="is-danger") {{ error }}
    b-notification(v-else :type="member.is_approved ? 'is-success' : 'is-danger'") {{ member.name }} {{ member.is_approved ? 'approved' : 'denied' }}
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';

export default {
  name: 'approve-member',
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      member: getters.GET_MEMBER,
    }),
  },
  async created() {
    this.settings.loading = true;
    if (this.account.id === undefined) {
      await this.$store.dispatch(actions.DO_GET_ACCOUNT, {
        id: process.env.NODE_ENV === 'development' ? 'cornerstoneworld.org' : window.location.host.replace(/admin\./, ''),
      });
      await this.approve();
    } else {
      await this.approve();
    }
    this.settings.loading = false;
  },
  data() {
    return {
      error: null,
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async approve() {
      try {
        await this.$store.dispatch(actions.DO_GET_MEMBER, {
          id: this.id,
        });
      } catch (e) {
        this.error = 'Invalid key';
      }
      if (this.member.id) {
        try {
          await this.$store.dispatch(actions.DO_UPDATE_MEMBER, {
            id: this.member.id,
            approval_key: this.id,
            is_approved: this.action === 'approve',
          });
        } catch (error) {
          this.error = error.response.data.data.error_message;
        }
      }
    },
  },
  props: {
    action: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ApproveMember.vue